import { bootstrap, type Feature } from "./core/bootstrap";
import { initBackToTop } from "./features/back-to-top";
import { initCvDownload } from "./features/cv-download";
import { initFaq } from "./features/faq";
import { initHeaderVisibility } from "./features/header-visibility";
import { initHomeBrand } from "./features/home-brand";
import { initMobileNavigation } from "./features/mobile-navigation";
import { initPageTransitions } from "./features/page-transitions";
import { initQualityCounter } from "./features/quality-counter";
import { initScrollIndicator } from "./features/scroll-indicator";
import { initWaveCanvases } from "./features/wave-canvas";

const features: Feature[] = [
  { name: "page transitions", initialize: initPageTransitions },
  { name: "mobile navigation", initialize: initMobileNavigation },
  { name: "header visibility", initialize: initHeaderVisibility },
  { name: "FAQ", initialize: initFaq },
  { name: "wave canvases", initialize: initWaveCanvases },
  { name: "home brand", initialize: initHomeBrand },
  { name: "CV download", initialize: initCvDownload },
  { name: "back to top", initialize: initBackToTop },
  { name: "quality counters", initialize: initQualityCounter },
  { name: "scroll indicator", initialize: initScrollIndicator },
];

function startApplication(): void {
  bootstrap(features);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", startApplication, { once: true });
} else {
  startApplication();
}
